import { render, staticRenderFns } from "./guidance.vue?vue&type=template&id=b631935e&scoped=true&lang=pug"
import script from "./guidance.vue?vue&type=script&lang=js"
export * from "./guidance.vue?vue&type=script&lang=js"
import style0 from "./guidance.vue?vue&type=style&index=0&id=b631935e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b631935e",
  null
  
)

export default component.exports